import { unitMapping } from '#src/lib/style.ts';

type Props = {
  size?: keyof typeof unitMapping;
  className?: string;
};
export const Snowflake = ({ className, size = 4 }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      style={{ width: unitMapping[size], height: unitMapping[size] }}
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.7631 1.78576L8.99997 2.80371V5.11311L9.99999 5.69047L12 4.53579L12 2.49989L14 2.49989L14 4.53577L15.7631 5.55373L14.7631 7.28578L13 6.26783L11 7.42253V8.57722L13 9.73192L14.7631 8.71398L15.7631 10.446L14 11.464V13.4999H12V11.464L9.99997 10.3093L8.99997 10.8866V13.196L10.7631 14.214L9.76311 15.946L7.99999 14.9281L6.23683 15.946L5.23683 14.214L6.99997 13.196V10.8866L5.99999 10.3093L3.99997 11.464L3.99997 13.4999H1.99997L1.99997 11.464L0.236816 10.446L1.23682 8.71399L2.99995 9.73194L4.99997 8.57723V7.42252L2.99999 6.26783L1.23685 7.28578L0.236847 5.55373L1.99997 4.53579L1.99997 2.49987H3.99997L3.99997 4.53577L5.99997 5.69047L6.99997 5.11312V2.80373L5.23684 1.78578L6.23684 0.0537291L7.99996 1.07167L9.76311 0.0537109L10.7631 1.78576ZM8.99997 7.99988C8.99997 8.55216 8.55225 8.99988 7.99997 8.99988C7.44768 8.99988 6.99997 8.55216 6.99997 7.99988C6.99997 7.44759 7.44768 6.99988 7.99997 6.99988C8.55225 6.99988 8.99997 7.44759 8.99997 7.99988Z"
        fill="currentColor"
      />
    </svg>
  );
};
